
import { PieChart, RingChart, BarChart } from './AnalysisCharts';
import UIFetchService from '../Service/UIFetchService';
import { toThousands } from '../Service/Utils';
import auth from '../Service/AuthFetchService';
import UserTable from './UserTable';

import React from 'react';
import { Dropdown, Menu, Form, Row, Col, Button, Progress, Divider, Modal, Select, Space, Cascader, Radio, Skeleton, Popover, Card, message, Tabs, Pagination, Table, Tag} from 'antd';
import { ExclamationCircleOutlined, EditOutlined, DeleteOutlined, DownOutlined, PlusOutlined, RedoOutlined, LoadingOutlined,LeftOutlined } from '@ant-design/icons';


const refreshHint = <div>
    <p><span style={{ color: 'green' }}>效果</span>：清除所有缓存并触发图表重新计算。</p>
    <p>在原始数据更新之后，可以重新计算获取最新值；</p>
    <p>正常情况下并<span style={{ color: 'red' }}>不需要</span>手动刷新。</p>
</div>


class UserClusteringAnalysis extends React.Component {
    constructor() {
        super();
        this.state = {
            definitions: [],
            chartModal: {
                visible: false,
                action: '',
                valid: {
                    name: {
                        status: '',
                        help: null
                    },
                    tag: {
                        status: '',
                        help: null
                    },
                    chartType: {
                        status: '',
                        help: null
                    }
                }
            },
            uncommittedChart: {
                name: null,
                tagId: null,
                chartType: 'CHART_BAR',
                valueType: 'PERCENT'
            },
            tagsOptions: [],
            charts: [],
            downloading: false,
            users: [],
            totalCountOfUsers: 0,
            pageNo:1,
            pageSize:10,
            tgiInfo:[]
        };
    }

    async componentDidMount() {
        const tags = await UIFetchService.get('/api/v1/metadata/tags/tree?filter=analysis');
        const tagsOptions = tags.map(category => {
            return {
                label: category.title,
                value: category.key,
                children: category.children.map(tag => {
                    return {
                        label: tag.title,
                        value: tag.key
                    };
                })
            };
        });
        const definitions = await UIFetchService.get('/api/v1/user_clustering/summaries');
        this.setState({ tagsOptions, definitions });
        this.refreshAllCharts();

        this.fetchClusterUsers(this.state.pageNo, this.state.pageSize);

        const tgi = await UIFetchService.get(`/api/v1/user_clustering/clusters/${this.props.clusteringId}/tgi`);
        this.setState({ tgiInfo: tgi });
        auth.appendLog('ClusteringAnalysis', this.props.clustering);
    }

    render() {
        const valid = this.state.chartModal.valid;
        return <>
            <Modal
                title={this.state.chartModal.action === 'edit' ? '编辑画像图表' : '添加画像图表'}
                visible={this.state.chartModal.visible}
                onOk={this.clusterChartDidFinished}
                onCancel={() => this.showClusterChartModal(false)}>
                <Form>
                    <Form.Item
                        label="标签"
                        validateStatus={valid.tag.status}
                        hasFeedback
                        help={valid.tag.help}
                    >

                        {this.state.chartModal?.action === 'edit'
                            ? <Cascader
                                options={this.state.tagsOptions}
                                value={this.state.uncommittedChart.tagId}
                                onChange={this.chartModalTagDidChanged}
                                disabled
                                placeholder="请选择标签" />
                            : <Cascader
                                options={this.state.tagsOptions}
                                value={this.state.uncommittedChart.tagId}
                                onChange={this.chartModalTagDidChanged}
                                placeholder="请选择标签" />}
                    </Form.Item>
                    <Form.Item
                        label="图表"
                        validateStatus={valid.chartType.status}
                        hasFeedback
                        help={valid.chartType.help}
                    >
                        <Radio.Group
                            onChange={this.chartModalChartTypeDidChanged}
                            defaultValue="CHART_BAR"
                            value={this.state.uncommittedChart.chartType}
                        >
                            <Radio value={'CHART_BAR'}>柱状图</Radio>
                            <Radio value={'CHART_RING'}>环装图</Radio>
                            <Radio value={'CHART_PIE'}>饼状图</Radio>
                        </Radio.Group>
                    </Form.Item>
                </Form>
            </Modal>
            <Row style={{ textAlign: 'left', padding: '0 10px 0 10px', margin: '0 0 10px 0' }}>
                <Col>
                    <span
                        style={{
                            color: 'gray',
                            cursor: 'pointer'
                        }}
                        onClick={() => window.location = '/user_profile/clustering'}
                    ><LeftOutlined /> 返回</span>
                </Col>
            </Row>
            <div style={{ height: '20px' }} />
            <Row style={{padding: '0 10px'}}>
                <Col span={10}>
                    <Row>
                        <Col>
                            <h2>{this.props.clustering.name} {!this.hasChartsLoaded() && <LoadingOutlined />} </h2>
                        </Col>
                    </Row>
                    <div style={{ height: '30px' }} />
                    <Row>
                        <Col flex="70px">
                            <Progress type="circle" percent={this.getClusterPercent()} width={70} />
                        </Col>
                        <Col flex="300px">
                            <Row>
                                <Col flex="10px" />
                                <Col flex="200px" style={{ textAlign: 'left' }}>
                                    <span style={{ fontSize: 27 }}>
                                        {toThousands(this.props.clustering.todayResult)}
                                    </span>
                                    <span>人</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col flex="10px" />
                                <Col flex="100%" style={{ textAlign: 'left' }}>
                                    <span style={{ color: 'gray', padding: '0px 14px' }} >
                                        在全部用户{toThousands(this.props.clustering.todayTotal)}人中占比{this.getClusterPercent()}%
                                    </span>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <div style={{ height: '30px' }} />
                    <Row>
                        <Col style={{ alignSelf: 'center' }}>
                            <span style={{ color: 'gray'}}>最新更新时间：{this.props.clustering.latestDate}</span>
                        </Col>
                    </Row>
                </Col>
                <Col span={14}>
                    <Row>
                        <Col>
                            <span>人群显著特征概览</span>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <span style={{ color: 'gray'}}>大盘TGI：人群包中该标签值的占比/整体用户中该标签值的占比，TGI&gt;1表示人群包在该标签值上的偏好相对整体更强。</span>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={16}>
                            <Table size='small' dataSource={this.state.tgiInfo} pagination={false} scroll={{ y: 160 }}>
                                <Table.Column
                                    title="标签值（仅展示TGI&gt;1的）"
                                    dataIndex="tagName"
                                    key="tagName"
                                    width={350}
                                    render={(_, record) => {return <Row><p style={{margin:'0 0'}}>{record.tagName}：</p> 
                                    <Tag color="processing" style={{height:'20px', margin:'0 0', border:'none'}}>{record.tagKey}</Tag></Row>}}/>
                                <Table.Column
                                    title="大盘TGI"
                                    key="tgi"
                                    dataIndex="tgi"/>
                            </Table>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Divider />
            <Tabs defaultActiveKey="clusterCharts">
                <Tabs.TabPane tab="群体画像" key="clusterCharts">
                <div style={{ height: '20px' }} />
                <Row justify="space-between">
                    <Col>
                        <Space>
                            <span>人群对比：</span>
                            <Select
                                showSearch
                                placeholder="选择人群"
                                style={{ width: 200 }}
                                onSelect={(_, option) => window.location = `
                                /user_profile/clustering/${this.props.clusteringId}/vs/${option.key}`}
                                filterOption={(input, option) => option.value.startsWith(input)}
                            >
                                {this.state.definitions.map(def => <Select.Option key={def.key} value={def.title}>{def.title}({def.value})</Select.Option>)}
                            </Select>
                        </Space>
                    </Col>
                    <Col>
                        <Space>
                            <Popover content={refreshHint} title="提示" >
                                <Button ghost
                                    type="primary"
                                    style={{fontSize: '12px'}}
                                    icon={<RedoOutlined />}
                                    disabled={!this.hasChartsLoaded()}
                                    onClick={this.clusterChartsDidRefreshAll}
                                >刷新</Button>
                            </Popover>
                            <div style={{ width: 10 }} />
                            <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={() => this.showClusterChartModal(true, 'create')}
                            >添加图表</Button>
                            {/* <Button
                                type="default"
                                onClick={() => this.exportPdf()}
                                disabled={this.state.downloading || !this.hasChartsLoaded()}
                            > {this.state.downloading && <LoadingOutlined />}导出PDF</Button> */}
                        </Space>
                    </Col>
                    
                </Row>
                <div style={{ height: '40px' }} />
                <Row id="charts-for-export">
                    {this.state.charts.map((chart, index) =>
                        <Col span={12}>
                            <Card size="small" style={{ margin: '0px 5px 10px' }} >
                                <Row justify="space-between" key={index} >
                                    <Col style={{ padding: '0px 0px' }}>
                                        <span style={{ fontSize: 15 }} >{this.getTagFullName(chart.tagId)}</span>
                                    </Col>
                                    {!chart.loading &&
                                        <Col style={{ padding: '0px 30px' }}>
                                            <Dropdown overlay={this.renderChartMenu(chart)} >
                                                <Button type="link" size="small"><DownOutlined /></Button>
                                            </Dropdown>
                                        </Col>}
                                </Row>
                                {!chart.loading &&
                                    <Row>
                                        <Col>
                                            <span style={{ fontSize: 11, color: 'gray' }} >拥有标签的{toThousands(chart.result?.total)}人占总人数的{chart.result?.totalPercent.toFixed(2)}%</span>
                                        </Col>
                                    </Row>
                                }
                                <Row>
                                    <Col flex="100%">
                                        {this.renderChart(chart, index)}
                                    </Col>
                                </Row>
                            </Card>
                        </Col>)}
                </Row>
                </Tabs.TabPane>
                <Tabs.TabPane tab="用户明细" key="userDetail">
                <Row>
                    <Col flex="100%">
                        <UserTable
                            dataSource={this.state.users}
                            onShowDetail={(bczUid) => window.open(`/user_profile/clustering/${this.props.clusteringId}/users/${bczUid}`)}
                            pagination={{
                                total: this.state.totalCountOfUsers,
                                current: this.state.pageNo,
                                pageSize: this.state.pageSize,
                            }}
                            onChange={(pagination) => {
                                this.fetchClusterUsers(pagination.current,pagination.pageSize)
                            }}
                        />
                    </Col>
                </Row>
                </Tabs.TabPane>
            </Tabs>
        </>
    }

    renderChartMenu(chart) {
        return <Menu onClick={(e) => {
            switch (e.key) {
                case 'Edit':
                    this.chartMenuDidEdit(chart);
                    break;
                case 'Invalidate':
                    this.chartMenuDidInvalid(chart);
                    break;
                case 'Delete':
                    this.chartMenuDidRemove(chart);
                    break;
                default:
                    break;
            }
        }}>
            <Menu.Item key="Edit" icon={<EditOutlined />} >
                编辑
            </Menu.Item>
            <Menu.Item key="Invalidate" icon={<RedoOutlined />} >
                刷新
            </Menu.Item>
            <Menu.Item key="Delete" icon={<DeleteOutlined />}>
                删除
            </Menu.Item>
        </Menu>
    }

    renderChart(chart, index) {
        if (chart.loading || !chart.result) {
            return <Skeleton active />;
        }

        switch (chart.chartType) {
            case 'CHART_BAR':
                return <BarChart dataSource={chart} />
            case 'CHART_RING':
                return <RingChart dataSource={chart} />
            case 'CHART_PIE':
                return <PieChart dataSource={chart} />
            default:
                return <></>
        }
    }

    hasChartsLoaded() {
        if (this.state.charts.length === 0) {
            return false;
        }
        for (let chart of this.state.charts) {
            if (chart.loading) {
                return false;
            }
        }
        return true;
    }

    chartMenuDidEdit(chart) {
        this.showClusterChartModal(true, 'edit', chart);
    }

    clusterChartsDidRefreshAll = () => {
        for (let chart of this.state.charts) {
            this.chartMenuDidInvalid(chart);
        }
    }

    // 使缓存无效，强制重新计算
    chartMenuDidInvalid(chart) {
        const refresh = () => {
            const charts = this.state.charts;
            chart.loading = true;
            this.setState({ charts });

            UIFetchService.get(`/api/v1/user_clustering/clusters/${this.props.clusteringId}/charts/${chart.id}`)
                .then((result) => {
                    chart.result = result;
                    chart.loading = false;
                    this.setState({ charts });
                    message.success(`图表"${this.getTagFullName(chart.tagId)}"已重新生成。`);
                });
        };
        const clusteringId = this.props.clusteringId;
        UIFetchService.method('PATCH', `/api/v1/user_clustering/clusters/${clusteringId}/charts/${chart.id}`)
            .then(() => refresh());
    }

    async chartMenuDidRemove(chart) {
        const refresh = () => {
            message.success(`图表"${chart.name}"已被删除。`);
            this.refreshAllCharts();
        };
        const clusteringId = this.props.clusteringId;
        Modal.confirm({
            title: `是否要删除图表：“${chart.name}“?`,
            icon: <ExclamationCircleOutlined />,
            content: '删除图表',
            onOk() {
                UIFetchService.method('DELETE', `/api/v1/user_clustering/clusters/${clusteringId}/charts/${chart.id}`)
                    .then(() => refresh());

            },
            onCancel() {
                //console.log('Cancel');
            },
        });
    }

    chartModalNameDidChanged = (e) => {
        const state = this.state.uncommittedChart;
        state.name = e.target.value;
        this.setState({ uncommittedChart: state });
        this.charModalValidate('name', { name: state.name });
    }

    chartModalTagDidChanged = (value) => {
        const state = this.state.uncommittedChart;
        state.tagId = value;
        this.setState({ uncommittedChart: state });
        this.charModalValidate('tag', { tagId: parseInt(state.tagId) });
    }

    chartModalChartTypeDidChanged = (e) => {
        const state = this.state.uncommittedChart;
        state.chartType = e.target.value;
        this.setState({ uncommittedChart: state });
        this.charModalValidate('chartType', { chartType: state.chartType });
    }

    chartModalValueTypeDidChanged = (e) => {
        const state = this.state.uncommittedChart;
        state.valueType = e.target.value;
        this.setState({ uncommittedChart: state });
    }

    charModalValidate(field, param) {
        const modal = this.state.chartModal;
        modal.valid[field] = {
            status: 'validating',
            help: ''
        };
        this.setState({ chartModal: modal });
        UIFetchService.post(`/api/v1/user_clustering/clusters/${this.props.clusteringId}/chart/validate`, param)
            .then((err) => {
                modal.valid[field] = err;
                this.setState({ chartModal: modal });
            });
    }

    clusterChartDidFinished = async () => {
        const state = this.state.chartModal;
        const chart = this.state.uncommittedChart;
        let success = true;
        if (chart.name === '' || chart.name === null) {
            state.valid.name.status = 'success';
            state.valid.name.help = '名称不能为空';
            success = false;
        }

        if (chart.tagId === 0 || chart.tagId === null) {
            state.valid.tag.status = 'error';
            state.valid.tag.help = '标签未选择';
            success = false;
        }

        if (chart.chartType === null || chart.chartType === '') {
            state.valid.chartType.status = 'error';
            state.valid.chartType.help = '图表类型未选择';
            success = false;
        }

        if (!success) {
            this.setState({ chartModal: state });
            return;
        }
        if (this.state.chartModal.action === 'edit') {
            this.postUpdateChart();
        } else {
            this.postAddChart();
        }
    }

    async postAddChart() {
        // <Skeleton active />
        const tagId = parseInt(this.state.uncommittedChart.tagId[1]);
        const id = await UIFetchService.post(`/api/v1/user_clustering/clusters/${this.props.clusteringId}/chart`,
            {
                tagId: tagId,
                chartType: this.state.uncommittedChart.chartType,
                valueType: this.state.uncommittedChart.valueType
            });
        if (!id) {
            return;
        }
        const charts = this.state.charts;
        const analysis = {
            id: id,
            tagId: tagId,
            tagName: this.getTagFullName(tagId),
            chartType: this.state.uncommittedChart.chartType,
            valueType: this.state.uncommittedChart.valueType,
            items: [],
            loading: true
        };
        charts.push(analysis);
        this.setState({ charts });
        this.showClusterChartModal(false);
        message.success('图表创建成功');
        UIFetchService.get(`/api/v1/user_clustering/clusters/${this.props.clusteringId}/charts/${id}`)
            .then((result) => {
                const charts = this.state.charts;
                analysis.result = result;
                analysis.loading = false;
                this.setState({ charts });
            });
    }

    async postUpdateChart() {
        // <Skeleton active />
        const tagId = parseInt(this.state.uncommittedChart.tagId[1]);
        const chartId = this.state.uncommittedChart.id;
        const id = await UIFetchService.put(`/api/v1/user_clustering/clusters/${this.props.clusteringId}/charts/${chartId}`,
            {
                id: this.state.uncommittedChart.id,
                tagId: tagId,
                chartType: this.state.uncommittedChart.chartType,
                valueType: this.state.uncommittedChart.valueType
            });
        if (!id) {
            return;
        }
        const charts = this.state.charts;
        const analysis = this.state.charts.find(chart => chart.id === id);
        analysis.chartType = this.state.uncommittedChart.chartType;
        analysis.valueType = this.state.uncommittedChart.valueType;
        this.setState({ charts });
        this.showClusterChartModal(false);
        message.success('图表更新成功');

        UIFetchService.get(`/api/v1/user_clustering/clusters/${this.props.clusteringId}/charts/${id}`)
            .then((result) => {
                const charts = this.state.charts;
                analysis.result = result;
                analysis.loading = false;
                this.setState({ charts });
            });
    }

    getTagFullName(tagId) {
        for (let category of this.state.tagsOptions) {
            for (let tag of category.children) {
                if (tag.value === tagId.toString()) {
                    return `${category.label} / ${tag.label}`
                }
            }
        }
        return ''
    }

    getClusterPercent() {
        return ((this.props.clustering.todayResult / this.props.clustering.todayTotal) * 100).toFixed(2);
    }

    showClusterChartModal(visible, action, chart) {
        let tagPath = []
        if (chart !== undefined) {
            for (let category of this.state.tagsOptions) {
                for (let tag of category.children) {
                    if (chart.tagId?.toString() === tag.value) {
                        tagPath = [category.label, tag.value];
                        break;
                    }
                }
            }
        }

        this.setState({
            chartModal: {
                visible: visible,
                action: (action === undefined ? '' : action),
                valid: {
                    name: {
                        status: '',
                        help: null
                    },
                    tag: {
                        status: '',
                        help: null
                    },
                    chartType: {
                        status: '',
                        help: null
                    }
                }
            },
            uncommittedChart: {
                id: chart?.id,
                name: chart?.name,
                tagId: tagPath,
                chartType: chart === undefined ? 'CHART_BAR' : chart.chartType,
                valueType: chart === undefined ? 'PERCENT' : chart.valueType
            }
        });
    }

    async refreshAllCharts() {
        const preparedCharts = await UIFetchService.get(`/api/v1/user_clustering/clusters/${this.props.clusteringId}/charts`);
        const charts = preparedCharts.map(chart=>{
            chart.loading = true;
            return chart;
        });
        for (let chart of charts) {
            UIFetchService.get(`/api/v1/user_clustering/clusters/${this.props.clusteringId}/charts/${chart.id}`)
                .then((result) => {
                    const charts = this.state.charts;
                    chart.result = result;
                    chart.loading = false;
                    this.setState({ charts });
                });
        }
        this.setState({ charts });
    }

    async exportPdf() {
        this.setState({ downloading: true });
        fetch(`/api/v1/user_clustering/clusters/${this.props.clusteringId}/export`)
            .then(response => {
                if (response.status === 500) {
                    this.setState({ downloading: false });
                    message.error('文件导出失败：数据还未准备好。');
                    return;
                }
                response.blob().then(blob => {
                    let blobUrl = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    let disposition = response.headers.get('Content-Disposition');
                    const fileName = disposition.match(/filename=(.+)/)[1];
                    a.href = blobUrl;
                    a.download = decodeURI(fileName);
                    a.click();
                    window.URL.revokeObjectURL(blobUrl);

                    this.setState({ downloading: false });
                });
            })
            .catch(e=>{
                this.setState({ downloading: false });
                message.error(`文件导出失败: ${e}`);
            });

    }

    async fetchClusterUsers(pageNo, pageSize) {
        let url = `/api/v1/user_clustering/clusters/${this.props.clusteringId}/users?pageNo=${pageNo}&pageSize=${pageSize}`;
        const page = await UIFetchService.get(url);
        this.setState({ users: page.items, totalCountOfUsers: page.total, pageNo: pageNo, pageSize: pageSize});
    }
}

export default UserClusteringAnalysis;